import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@/view/components/ui/use-toast'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'
import { apiFGTS, httpClient } from '@/app/services/http/httpClient'

export const useLoginController = () => {
  const { login, whitelabel, logout, showCodeScreen } = useWhitelabelContext()
  const [code, setCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    if (!showCodeScreen) {
      if (whitelabel) logout()
      navigate('/signIn')
    }
  }, [showCodeScreen, navigate])

  const lenght = 6
  const isValid = useMemo(() => code.length === lenght, [code])

  useEffect(() => {
    const handleLogin = async () => {
      if (whitelabel) {
        httpClient.defaults.baseURL = whitelabel.url
        apiFGTS.defaults.baseURL = whitelabel.url
        navigate('/signIn')
      }
    }

    handleLogin()
  }, [whitelabel])

  const handleAccess = async () => {
    console.log(code)
    try {
      setIsLoading(true)
      if (!isValid) throw new Error('Código inválido')

      await login(code)
      navigate('/signIn')

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title: error.message || error,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    code,
    setCode,
    handleAccess,
    isValid,
    isLoading,
    lenght,
  }
}
